export const SET_SESSION_DURATION = 'SET_SESSION_DURATION';
export const SET_SESSION_ENABLED = 'SET_SESSION_ENABLED';
export const SET_SESSION_LIMIT = 'SET_SESSION_LIMIT';
export const SET_SESSION_TIMEOUT_SHOWN = 'SET_SESSION_TIMEOUT_SHOWN';

export const setSessionDurationAction = duration => ({
    type: SET_SESSION_DURATION,
    payload: duration
});

export const setSessionEnabledAction = enabled => ({
    type: SET_SESSION_ENABLED,
    payload: enabled
});

export const setSessionLimitAction = sessionLimit => ({
    type: SET_SESSION_LIMIT,
    payload: sessionLimit
});

export const setSessionTimeoutShownAction = isShown => ({
    type: SET_SESSION_TIMEOUT_SHOWN,
    payload: isShown
});
